import { FC, memo, useState } from 'react'

import { ChevronDownIcon } from '@cash-me/react-components'

import { AccordionItemProps } from './Accordion.model'
import * as S from './Accordion.styles'

export const AccordionNoRadix: FC<AccordionItemProps> = memo(
  ({
    id,
    className = '',
    chevronColor,
    title,
    subtitle,
    children,
    titleAs: TitleTag = 'h3',
    subtitleAs: SubtitleTag = 'span',
    style
  }) => {
    const [isOpen, setOpen] = useState(false)

    return (
      <S.Item
        className={`ds-accordion-item ${className}`}
        style={style}
        id={id}
        data-testid={id ? `ds-accordion-item-${id}` : undefined}
        onToggle={event => setOpen(event.currentTarget.open)}
      >
        <S.Header className={isOpen ? 'open' : 'closed'} aria-expanded={isOpen}>
          <div>
            {typeof title === 'string' ? (
              <S.Title as={TitleTag} className="ds-accordion-title">
                {title}
              </S.Title>
            ) : (
              title
            )}
            {subtitle && typeof subtitle === 'string' ? (
              <S.Subtitle as={SubtitleTag} className="ds-accordion-subtitle">
                {subtitle}
              </S.Subtitle>
            ) : (
              subtitle
            )}
          </div>
          <ChevronDownIcon
            className="ds-accordion-arrow"
            color={chevronColor || 'var(--colors-primary-icon-default)'}
          />
        </S.Header>
        {children}
      </S.Item>
    )
  }
)

AccordionNoRadix.displayName = 'AccordionNoRadix'
